import { render, staticRenderFns } from "./account_center.vue?vue&type=template&id=6bbc1e4b&scoped=true"
import script from "./account_center.vue?vue&type=script&lang=ts"
export * from "./account_center.vue?vue&type=script&lang=ts"
import style0 from "./account_center.vue?vue&type=style&index=0&id=6bbc1e4b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bbc1e4b",
  null
  
)

export default component.exports